import { render, staticRenderFns } from "./LeadStatusesView.vue?vue&type=template&id=1f652fbf&scoped=true&"
import script from "./LeadStatusesView.vue?vue&type=script&lang=js&"
export * from "./LeadStatusesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f652fbf",
  null
  
)

export default component.exports